module.exports = __webpack_public_path__ + "static/media/Cubrimos-Cada-Rincon.195053b0.svg";